
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <h5><b>Category: {{ this.$route.query.name }}</b></h5>
      <div v-for="data in products" :key="data.id" class="col-xl-3 col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="product-img position-relative">
              <div class="product-ribbon">
                <span class="bg-dark text-white p-2 rounded-2 small">{{ data.category.name }}</span>
              </div>
              <router-link :to="{ path: '/product', query: { id: data.product_id }}">
                <img :src="getFiles(data.photo)" class="img-fluid mx-auto d-block"/>
              </router-link>
            </div>
            <div class="mt-4 text-center">
              <h5 class="mb-3 text-truncate">
                <router-link tag="a" class="text-dark" :to="{ path: '/product', query: { id: data.product_id }}">{{ data.name }}</router-link>
              </h5>
              <h5 class="my-0"><b>AED {{ commas(data.price) }}</b></h5>
            </div>
          </div>
        </div>
      </div>
      <div v-if="products.length<=0" class="text-center p-4">
          <i class="fas fa-shopping-cart fa-4x"></i>
          No Services Found<br><br>
          <router-link tag="a" to="/products" class="btn btn-sm btn-success" >View Services</router-link>
      </div>
    </div>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { productMethods, productComputed } from "@/state/helpers";

export default {
  page: {
    title: "Services by Category",
    meta: [{name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Services by Category",
      items: [
        {text: "Ecommerce",href: "/",},
        {text: "Category",active: true, },
      ],
    };
  },
  mounted() {
    this.FindByCategory(this.$route.query.id);
  },
  computed: {
    ...productComputed,
  },
  methods: {
    ...productMethods,
    getFiles(name){
      let url = axios.defaults.baseURL;
      let imagelink = (url).slice(0,-3)+"products/"+name;
      return imagelink;
    },
    FindByCategory(category){
      this.filterProductsByCategory({category:category});
    },
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
  },
};
</script>